const Quill = require('quill');
const Parchment = Quill.imports.parchment;

    /**
     * Creates a custom QuillJS blot that is not directly editable. 
     * Utilized by calling `this.editor.insertEmbed(IndexOfPlacement, Blot.name (i.e. subLabel), {id: String, label: string})`
     */

class SubLabelBlot extends Parchment.Embed {
    /**
     * Create a blot.
     * @param {object} value - an object with an id and label
     * 
     * Parchment.Embed create method to make dom node and assigns values to the node
     */

    static create(value) {
        const node = super.create(value);
        node.setAttribute('data-id', value.id)
        node.setAttribute('data-label', value.label)
        node.setAttribute('spellcheck', false)
        node.setAttribute('contenteditable', false)
        node.setAttribute('data-href', value.href)
        node.addEventListener('click', (e) => {
          window.open(node.getAttribute('data-href'), "_blank");
        });
        node.innerText = value.label;
        return node;
    }

    static value(node) {
        return node.dataset
    }

  /**
   * Override to length property to prevent user from directly deleting blot
   */

    length() {
        return 1
    }

  /**
   * Override to deleteAt property to prevent user from directly deleting blot
   */
    
    deleteAt() {
        return false
    }
}

/** 
 * @property blotName  - Name given when insertingBlot into editor
 * @property tagName   - type of HTML tag used for blot dom node
 * @property className - class added to dom node
*/

SubLabelBlot.blotName = 'subLabel';
SubLabelBlot.tagName = 'span';
SubLabelBlot.className = 'ql-label';

/**
 * Module used in quill to prevent the user from directly deleting substitution blot
 */

class SubLabel {

  /**
   * Creates SubLabel module and adds onTextChange events to prevent deletion
   * @param {Quill} quill 
   * @param {Object} options 
   */
    constructor(quill, options) {
      this.quill = quill
      this.onTextChange = this.onTextChange.bind(this)
      
      this.quill.on(Quill.events.TEXT_CHANGE, this.onTextChange)
    }
  
    onTextChange(_, oldDelta, source) {
      if (source !== Quill.sources.API) {
        const currrentContents = this.quill.getContents()
        const delta = currrentContents.diff(oldDelta)
        
        const revertOps = delta.ops.filter(op => op.insert && op.insert.placeholder)
        if (!revertOps.length) return
        
        const [retainOp, ] = delta.ops.filter(op => op.retain)
        
        if (retainOp) {
          this.quill.updateContents(new Delta([retainOp, ...revertOps]))
          this.quill.setSelection(retainOp.retain + 1 + revertOps.length)
        } else {
          this.quill.updateContents(new Delta(revertOps))
          this.quill.setSelection(revertOps.length)
        }
      }
    }
}

/**
 * Registering the blot and module with the global quill object to be used elsewhere
 */

Quill.register(SubLabelBlot, false);
Quill.register('modules/subLabel', SubLabel)